<label
  nz-checkbox
  [ngModel]="timelineModalFilterService.showOnlyQualifiedStaff$ | async"
  (ngModelChange)="qualifiedStaffChanged($event)"
>
  {{ 'page.staff_assignment.filters.include_only_qualified_staff' | translate }}
</label>
